import Dialog from '@mui/material/Dialog'

import type { GeblokkeerdeWeek } from '../../../../planning/types/GeblokkeerdeWeek'
import type { ProcesstapHoofdleiding } from '../../../../status/types/ProcesstapHoofdleiding'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'
import type { OptionsDialogData } from '../../types/OptionsDialogData'
import { Aannemer } from '../dialogs/Aannemer'
import { Disciplines } from '../dialogs/Disciplines'
import { Gebiedswissel } from '../dialogs/Gebiedswissel'
import { Herplan } from '../dialogs/Herplan'
import { Labels } from '../dialogs/Labels'
import { NetbeheerderDisciplineReferentie } from '../dialogs/NetbeheerderDisciplineReferentie'
import { NetbeheerderTracelengte } from '../dialogs/NetbeheerderTracelengte'
import { Processtap } from '../dialogs/Processtap'
import { TechnischGereed } from '../dialogs/TechnischGereed'
import { Verantwoordelijke } from '../dialogs/Verantwoordelijke'
import { WijzigenGeschovenNaarAannemer } from '../dialogs/WijzigenGeschovenNaarAannemer'

type Props = {
  open: boolean
  type: OptionsDialogData['type']
  project: HoofdleidingProject
  selectableLabels: string[]
  onClose: () => void
  processtappen: ProcesstapHoofdleiding[]
  geblokkeerdeWeken: GeblokkeerdeWeek[]
}

export const ProjectOptionsDialog = ({
  open,
  type,
  project,
  onClose,
  processtappen,
  geblokkeerdeWeken,
  selectableLabels,
}: Props) => {
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      {type === 'labels' && (
        <Labels
          project={project}
          selectableLabels={selectableLabels}
          handleClose={onClose}
        />
      )}
      {type === 'herplanning' && (
        <Herplan
          project={project}
          handleClose={onClose}
          geblokkeerdeWeken={geblokkeerdeWeken}
        />
      )}
      {type === 'hoofdleiding_aannemer' && (
        <Aannemer project={project} handleClose={onClose} />
      )}
      {type === 'hoofdleiding_disciplines' && (
        <Disciplines project={project} handleClose={onClose} />
      )}
      {type === 'hoofdleiding_processtap' && (
        <Processtap
          project={project}
          handleClose={onClose}
          processtappen={processtappen}
        />
      )}
      {type === 'technisch_gereed' && (
        <TechnischGereed project={project} handleClose={onClose} />
      )}
      {type === 'hoofdleiding_referentie' && (
        <NetbeheerderDisciplineReferentie
          project={project}
          handleClose={onClose}
        />
      )}
      {type === 'hoofdleiding_tracelengte' && (
        <NetbeheerderTracelengte project={project} handleClose={onClose} />
      )}
      {type === 'hoofdleiding_verantwoordelijke' && (
        <Verantwoordelijke project={project} handleClose={onClose} />
      )}
      {type === 'hoofdleiding_gebiedswissel' && (
        <Gebiedswissel project={project} handleClose={onClose} />
      )}
      {type === 'wijzigen_geschoven_naar_aannemer' && (
        <WijzigenGeschovenNaarAannemer
          project={project}
          handleClose={onClose}
        />
      )}
    </Dialog>
  )
}
